import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.module.scss';

const UnitBlock = ({children, className, subheader, mandatoryMark = true}) => {
  return (
    <div className={classnames(styles.unit, className)}>
      {subheader && (
          <h3 className={styles.subHeader}>
            {mandatoryMark && <span className={styles.mandatoryMark}>*</span>}
            {subheader}
          </h3>
      )}
      {children}
    </div>
  );
};

UnitBlock.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  subheader: PropTypes.node,
  mandatoryMark: PropTypes.bool,
};

export default UnitBlock;
